import React, { useMemo } from 'react';
import { ReportTimeFrame } from '@tribeplatform/gql-client/types';
import { AnalyticsFeeder, generateAnalyticsQuery, SCORE_SELECT_QUERY, } from '@tribeplatform/react-components/Analytics/utils';
import { dayjs } from '@tribeplatform/react-components/common';
import { useNetwork } from '@tribeplatform/react-sdk/hooks';
import { LeaderboardList } from './LeaderboardList.js';
import { LoadingState } from './LoadingState.js';
export const LeaderboardTab = ({ timeFrame, spaceId, membersCount, excludeStaff, showScore, }) => {
    const { data: network } = useNetwork();
    const query = useMemo(() => {
        var _a, _b;
        let from = 0;
        if (timeFrame === ReportTimeFrame.allTime) {
            from = dayjs((_a = network === null || network === void 0 ? void 0 : network.createdAt) !== null && _a !== void 0 ? _a : 0).unix() * 1000;
        }
        else if (timeFrame === ReportTimeFrame.lastThirtyDays) {
            from = dayjs().subtract(30, 'day').unix() * 1000;
        }
        else if (timeFrame === ReportTimeFrame.lastSevenDays) {
            from = dayjs().subtract(6, 'day').unix() * 1000;
        }
        return generateAnalyticsQuery({
            selects: [
                {
                    field: 'person',
                    as: 'person',
                },
                {
                    field: SCORE_SELECT_QUERY,
                    as: 'score',
                },
            ],
            groupBy: { field: 'person' },
            order: { by: 'score', dir: 'desc' },
            timeFrame: { from, to: dayjs().unix() * 1000 },
            where: [
                { field: 'network', value: (_b = network === null || network === void 0 ? void 0 : network.id) !== null && _b !== void 0 ? _b : '' },
                ...(spaceId ? [{ field: 'space', value: spaceId }] : []),
                { field: 'space_type', in: ['GROUP', 'BROADCAST'] },
                { field: 'person', operator: '!=', value: null },
            ],
            having: [{ field: 'score', operator: '>', value: 0 }],
            limit: membersCount + 40,
        });
    }, [membersCount, network === null || network === void 0 ? void 0 : network.createdAt, network === null || network === void 0 ? void 0 : network.id, timeFrame, spaceId]);
    return (React.createElement(AnalyticsFeeder, { queries: [query], fields: { entities: { person: { profilePicture: 'all' } } } }, ({ data, isLoading }) => (React.createElement(React.Fragment, null, isLoading ? (React.createElement(LoadingState, { count: membersCount })) : (React.createElement(LeaderboardList, { data: data, count: membersCount, showScore: showScore, excludeStaff: excludeStaff }))))));
};
//# sourceMappingURL=LeaderboardTab.js.map